import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PasskeyOtpPreference {
  type: string;
  value: string;
}

export interface PasskeyOtpPreferencesState {
  loading: boolean;
  preferences: PasskeyOtpPreference[];
  accountId: string | null;
  customerId: string | null;
  error: any | null;
}

const initialState: PasskeyOtpPreferencesState = {
  loading: false,
  preferences: [],
  accountId: null,
  customerId: null,
  error: null,
};

const passkeyOtpPreferencesSlice = createSlice({
  name: 'passkeyOtpPreferences',
  initialState,
  reducers: {
    passkeyPreferencesRequest(
      state,
      _action: PayloadAction<{ username: string; passkeyToken: string }>
    ) {
      state.loading = true;
      state.error = null;
    },
    passkeyPreferencesSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.preferences = action.payload?.preferences ?? [];
      state.accountId = action.payload?.accountId ?? null;
      state.customerId = action.payload?.customerId ?? null;
      state.error = null;
    },
    passkeyPreferencesFailure(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetPasskeyPreferences() {
      return initialState;
    },
  },
});

export const {
  passkeyPreferencesRequest,
  passkeyPreferencesSuccess,
  passkeyPreferencesFailure,
  resetPasskeyPreferences,
} = passkeyOtpPreferencesSlice.actions;

export default passkeyOtpPreferencesSlice.reducer;
